// Client-side URL redirects. Must load first/blocking in <head> so the
// redirect fires before the rest of the page parses/renders.
//
// `from`:
//   - starting with '/' -> matches the path on the CURRENT domain only
//   - otherwise (e.g. 'ryzon.com/de/*') -> matches host+path, so it can
//     redirect across domains (old domain -> myviriations.com)
// `*` is a single wildcard. If `to` also contains `*`, the matched
// wildcard portion is substituted in; otherwise `to` is used as-is.
const REDIRECTS = [
  { from: 'ryzon.com/de/*', to: 'https://myviriations.com/*' },
  { from: 'ryzon.co.uk/de/*', to: 'https://myviriations.com/*' }
];

function redirectIfMatch() {
  const path = window.location.pathname;
  const host = window.location.hostname.replace(/^www\./, '');
  const hostAndPath = host + path;

  for (let i = 0; i < REDIRECTS.length; i++) {
    const { from, to } = REDIRECTS[i];  
    const isPathOnly = from.charAt(0) === '/';
    const subject = isPathOnly ? path : hostAndPath;

    if (from.indexOf('*') === -1) {
      if (subject === from) {
        window.location.replace(to);
        return;
      }
      continue;
    }

    const pattern = from
      .replace(/[.+?^${}()|[\]\\]/g, '\\$&')
      .replace(/\*/g, '(.*)');

    const match = new RegExp('^' + pattern + '$').exec(subject);

    if (match) {
      const destination = to.indexOf('*') === -1 ? to : to.replace(/\*/g, match[1] || '');
      window.location.replace(destination);
      return;
    }
  }
}

redirectIfMatch();
